export default ({ request }) => ({
    orderDemandMaterialListApi(data = {}) {
        return request({
            url: '/factory/order/demand/material/list',
            method: 'post',
            data
        })
    },
    orderDemandMaterialDetailApi(data = {}) {
        return request({
            url: '/factory/order/demand/material/detail',
            method: 'post',
            data
        })
    },
    orderDemandMaterialAddSaveApi(data = {}) {
        return request({
            url: '/factory/order/demand/material/add/save',
            method: 'post',
            data
        })
    },
    orderDemandMaterialEditSaveApi(data = {}) {
        return request({
            url: '/factory/order/demand/material/edit/save',
            method: 'post',
            data
        })
    },
    orderDemandMaterialDelApi(data = {}) {
        return request({
            url: '/factory/order/demand/material/del',
            method: 'post',
            data
        })
    },
    orderGoodsSpecMaterialListApi(data = {}) {
        return request({
            url: '/factory/order/goods/spec/material/list',
            method: 'post',
            data
        })
    },
    orderGoodsSpecMaterialSaveApi(data = {}) {
        return request({
            url: '/factory/order/goods/spec/material/save',
            method: 'post',
            data
        })
    },
    orderGoodsSpecMaterialDelApi(data = {}) {
        return request({
            url: '/factory/order/goods/spec/material/del',
            method: 'post',
            data
        })
    },

})
